<template>
  <div class="Information">
    <div class="mine_title">
      Account Information
    </div>
    <div class="editclass" @click="openDialog">
      <i class="el-icon-edit-outline
"></i>
      Edit
    </div>
    <!-- 内容 -->
    <div class="info">
      <p class="inforow" v-if="info.last_name">
        <span class="inforow-l">Last Name</span>
        <span class="inforow-r">{{ info.last_name }}</span>
      </p>

      <p class="inforow" v-if="info.first_name">
        <span class="inforow-l">First Name</span>
        <span class="inforow-r">{{ info.first_name }}</span>
      </p>

      <p class="inforow" v-if="info.alias">
        <span class="inforow-l">Display Name</span>
        <span class="inforow-r">{{ info.alias }}</span>
      </p>

      <p class="inforow" v-if="info.mobile">
        <span class="inforow-l">Phone number</span>
        <span class="inforow-r">{{ '+' + info.country_code + ' ' + info.mobile }}</span>
      </p>

      <p class="inforow" v-if="info.email">
        <span class="inforow-l">Email</span>
        <span class="inforow-r">{{ info.email }}</span>
      </p>

      <p class="inforow" v-if="info.timezone">
        <span class="inforow-l">Time Zone</span>
        <span class="inforow-r">{{ info.timezone }}</span>
      </p>

      <p class="inforow" v-if="info.nationality">
        <span class="inforow-l">Nationality</span>
        <span class="inforow-r">{{ info.nationality }}</span>
      </p>

      <p class="inforow" v-if="info.invite_code">
        <span class="inforow-l">Invitation code：<span style="display: inline-block;margin-right: 8px;">{{
          info.invite_code }}</span> <i @click="copy(info.invite_code)" style="cursor: pointer;"
            class="el-icon-document-copy"></i></span>
      </p>
    </div>

    <!-- 弹框 -->
    <el-dialog :visible.sync="showDetailFlag" title="Account Information" width="666px" custom-class="editdetailDialog"
      @close="closedialogEvent">
      <div>
        <el-form :model="ruleForm" status-icon label-position="left" :rules="rules" ref="ruleForm" label-width="115px"
          class="demo-ruleForm">
          <el-form-item label="Last Name" prop="last_name">
            <el-input v-model="ruleForm.last_name" placeholder="Please enter your last name"></el-input>
          </el-form-item>
          <el-form-item label="First Name" prop="first_name">
            <el-input v-model="ruleForm.first_name" placeholder="Please enter your first name"></el-input>
          </el-form-item>
          <el-form-item label="Display Name" prop="alias">
            <el-input v-model="ruleForm.alias" placeholder="Please enter your display name"></el-input>
          </el-form-item>
          <el-form-item label="Phone number" prop="">
            <el-select v-model="ruleForm.areaCode" collapse-tags @change="changeCodeforget">
              <div class="el-input_search">
                <img src="../../../assets/search.svg" /><input type="text" placeholder="Search Area Code"
                  class="el-input__inner" v-model="dropDownValue" @keyup="dropDownSearch">
              </div>
              <el-option v-for="item in areaCodeData" :key="item.id" :label="'+' + item.country_code + ' ' + item.title"
                :value="item.id">+{{ item.country_code }} {{ item.title }}</el-option>
            </el-select>
            <el-input oninput="value=value.replace(/\D/gi,'')" style="display: inline-block;width: 58%;" type="text"
              v-model="ruleForm.mobile" autocomplete="off" :maxlength="maxforget"
              placeholder="Enter phone number"></el-input>
          </el-form-item>
          <el-form-item label="" prop="">
            <div class="codebox">
              <el-input v-model="ruleForm.code" class="codeInput"></el-input>
              <el-button class="borderBtn codebtn" @click="countDown()" v-if="maxTotaltime == setTime || setTime == 0">Send
                Code</el-button>
              <el-button class="borderBtn codebtn" v-else>Resend Code (<span>{{ setTime }}</span>s)</el-button>
            </div>
          </el-form-item>
          <el-form-item label="Email" prop="">
            <el-input v-model="ruleForm.email" placeholder="Please enter your email"></el-input>
          </el-form-item>
          <el-form-item label="" prop="">
            <div class="codebox">
              <el-input v-model="ruleForm.email_code" class="codeInput"></el-input>
              <el-button class="borderBtn codebtn" @click="countDownE()"
                v-if="maxTotaltimeE == setTimeE || setTimeE == 0">Send Code</el-button>
              <el-button class="borderBtn codebtn" v-else>Resend Code (<span>{{ setTimeE }}</span>s)</el-button>
            </div>
          </el-form-item>
          <el-form-item label="Nationality" prop="">
            <el-input v-model="ruleForm.nationality" placeholder="Please enter your nationality"></el-input>
          </el-form-item>
          <span class="dialog-footer">
            <el-button class="cancelbtn1" @click="showDetailFlag = false">Cancel</el-button>
            <el-button class="Confirmbtn1" @click="tohandleEditdialog('ruleForm')">Confirm</el-button>
          </span>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store/store'
export default {
  components: {

  },
  data() {
    return {
      //页面数据
      info: {},
      //弹框
      showDetailFlag: false,
      //表单校验
      rules: {
        last_name: [{
          required: true, message: 'Please enter your last name', trigger: 'blur'
        }],
        first_name: [{
          required: true, message: 'Please enter your first name', trigger: 'blur'
        }],
        alias: [{
          required: true, message: 'Please enter your display name', trigger: 'blur'
        }],

      },
      //表单数据
      ruleForm: {
        last_name: '',
        first_name: '',
        alias: '',
        mobile: '',
        email: '',
        nationality: '',
        country_code: '',
        code: '',
        areaCode: '',
      },
      areaCodeData: [],//国家区号列表
      dropDownValue: '',
      maxforget: 10,//手机号码长度
      max: 10,//手机号码长度
      qvhao: [],//国家区号列表
      // 验证码倒计时
      maxTotaltime: 60,//定时器
      setTime: 60,//定时器
      maxTotaltimeE: 60,//定时器
      setTimeE: 60,//定时器
      timer: null,//定时器
      timerE: null,//定时器
    };
  },
  mounted() {
    this.getInfo()
    this.areaCodeData = store.getAreaCode()
    this.qvhao = store.getAreaCode()
  },
  methods: {
    // 倒计时
    setCountE(setTime) {
      if (setTime >= 0) {
        if (!this.timerE) {
          this.timerE = setInterval(() => {
            if (this.setTimeE > 0 && this.setTimeE <= this.maxTotaltimeE) {
              this.setTimeE--
            } else {
              clearInterval(this.timerE)
              this.timerE = null
              this.setTimeE = 60
            }
          }, 1000)
        }
      }
    },
    countDownE() {
      console.log(this.ruleForm);

      if (!this.ruleForm.email) {
        this.$message({
          message: 'Email cannot be empty.',
          type: 'warning'
        })
        return false
      }
      if (this.maxTotaltimeE == this.setTimeE) {
        this.$http.post('/tutor/api/sendEmailCode', {
          email: this.ruleForm.email,
        }).then((res) => {
          if (res.data.code == 200) {
            this.setCountE(this.setTimeE)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      }
    },
    // 倒计时
    setCount(setTime) {
      if (setTime >= 0) {
        if (!this.timer) {
          this.timer = setInterval(() => {
            if (this.setTime > 0 && this.setTime <= this.maxTotaltime) {
              this.setTime--
            } else {
              clearInterval(this.timer)
              this.timer = null
              this.setTime = 60
            }
          }, 1000)
        }
      }
    },
    countDown() {
      if (!this.ruleForm.mobile) {
        this.$message({
          message: 'Phone number cannot be empty.',
          type: 'warning'
        })
        return false
      }
      if (this.maxTotaltime == this.setTime) {
        this.$http.post('/api/login/verify-code', {
          mobile: this.ruleForm.mobile,
          length: 6,
          country_code: this.ruleForm.country_code
        }).then((res) => {
          if (res.data.code == 200) {
            this.setCount(this.setTime)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      }
    },
    dropDownSearch() {
      var _this = this
      if (_this.dropDownValue) {
        _this.areaCodeData = []
        _this.qvhao.find(item => {
          let name = ' +' + item.country_code + item.title
          if (name.indexOf(_this.dropDownValue) != -1) {
            _this.areaCodeData.push(item)
          }
        })
      } else {
        _this.areaCodeData = _this.qvhao
      }
    },
    changeCodeforget() {
      this.areaCodeData.map((item) => {
        if (this.ruleForm.areaCode == item.id) {
          this.ruleForm.country_code = item.country_code
        }
      });
      if (this.ruleForm.country_code == '86') {
        if (this.ruleForm.mobile.length > 11) {
          this.ruleForm.mobile = ''
        }
        this.maxforget = 11
      } else if (this.ruleForm.country_code == '1') {
        if (this.ruleForm.mobile.length > 10) {
          this.ruleForm.mobile = ''
        }
        this.maxforget = 10
      } else {
        this.maxforget = 15
      }
    },
    getInfo() {
      this.$http.get("/tutor/api/accountInfo").then((res) => {
        if (res.data.code == 200) {
          this.info = res.data.data;
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
          });
        }
      })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    copy(text) {
      navigator.permissions.query({ name: 'clipboard-write' }).then(result => {
        if (result.state === 'granted' || result.state === 'prompt') {
          // 可以写入剪贴板
          try {
            navigator.clipboard.writeText(text);
            this.$message({
              type: 'success',
              message: 'Copy successful!',
            })
          } catch (err) {
            this.$message({
              type: 'error',
              message: 'The content cannot be copied: ' + err,
            })
          }
        }
      });
    },
    openDialog() {
      this.ruleForm = JSON.parse(JSON.stringify(this.info))
      let id = this.areaCodeData.filter(e => {
        if (this.ruleForm.country_code.indexOf(e.country_code) != -1) {
          return e
        }
      })
      console.log(id, '--------------------sda');
      this.ruleForm.country_code
      this.ruleForm.areaCode = id ? id[0].id : this.areaCodeData[0].id
      console.log(this.ruleForm.areaCode, '--------------------sda');
      this.ruleForm.country_code = this.areaCodeData[0].country_code
      this.changeCodeforget()
      this.showDetailFlag = true
    },
    closedialogEvent() {
      this.showDetailFlag = false
    },
    edithandleClose(formName) {
      this.$refs[formName].resetFields();
    },
    tohandleEditdialog(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.ruleForm.email == this.info.email) {
          //   this.ruleForm.email = ''
          // }
          this.$http.post('/tutor/api/accountEdit', this.ruleForm).then(res => {
            if (res.data.code == 200) {
              this.info = { ...JSON.parse(JSON.stringify(this.ruleForm)), ...this.info }
              this.showDetailFlag = false
              this.getInfo()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.Information {
  background: #fff;
  padding: 0 24px;
  position: relative;
  .mine_title {
    font-family: Roboto;
    font-size: 24px;
    font-weight: 600;
    font-feature-settings: "kern" on;
  }

  .info {
    margin-top: 10px;

    .inforow {
      line-height: 4;
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;

      .inforow-l {
        color: #6B7280;
        width: 386px;
        display: inline-block;
      }
    }
  }

  .editclass {
    color: #ff904D;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }

  /deep/ .editdetailDialog {
    background: #fffae5;

    .el-dialog__title {
      font-size: 22px;
    }

    .el-dialog__header {
      padding: 24px;
    }

    .el-dialog__body {
      padding: 0 24px 24px 24px !important;

      .codebox {
        display: flex;
        flex-direction: row;

        .codeInput {
          display: inline-block;
        }

        .codebtn {
          background-color: #ff904D;
          margin-left: 20px;
          display: inline-block;
          color: #fff;
        }
      }
    }

    .dialog-footer {
      width: 100%;
    }

    .cancelbtn1 {
      width: 48%;
      background: transparent;
      color: #666;
      border: 1px solid #ccc;
    }

    .Confirmbtn1 {
      width: 48%;
      height: 45px;
      margin-left: 2%;
      color: #fff;
      background: #ff904d;
      border: none;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/childrens/Information.vue